import cfg from 'cfg';
import { requestAsync, httpMethods, UPDATE_DEFAULT } from 'dash-front/requery/actions';
import {
    LINEUP_TEMPLATE,
    SEARCH_INPUT_TEXT,
    PARTICIPANT_PITCH,
    ID_LINEUP,
    LINEUP_TYPE,
    PARTICIPANT_CUSTOM_NAME,
    PARTICIPANT_CUSTOM_TEXT,
    PITCH_LINEUP_TEMPLATE
} from './constants';
import { SET, DELETE, POST, GENERATE } from '../constants';

export const toIdArray = ar => ar.reduce((acc, el) => (el.id ? acc.concat(el.id) : acc), []);

export const fetchTournaments = () =>
    requestAsync({
        url: `${cfg.apis.ss2}/tournaments`,
        update: {
            tournaments: UPDATE_DEFAULT.MERGE
        },
        transform: body => ({
            tournaments: body.reduce((acc, el) => ({ ...acc, [el.id]: el }), {})
        }),
        list: body => ({
            tournaments: () => toIdArray(body)
        }),
        queryKey: 'GET:tournaments',
        options: {
            method: httpMethods.GET
        }
    });

export const fetchPlayers = (ttId = '') =>
    requestAsync({
        url: `${cfg.apis.ss2}/players?ttId=${ttId}`,
        update: {
            players: UPDATE_DEFAULT.MERGE
        },
        transform: body => ({
            players: body.reduce((acc, el) => ({ ...acc, [el.id]: el }), {})
        }),
        list: body => ({
            players: () => toIdArray(body)
        }),
        queryKey: 'GET:players',
        options: {
            method: httpMethods.GET
        }
    });

export const fetchTeams = (ttId = '') =>
    requestAsync({
        url: `${cfg.apis.ss2}/tournaments/${ttId}/teams`,
        update: {
            teams: UPDATE_DEFAULT.MERGE
        },
        transform: body => ({
            teams: body.reduce((acc, el) => ({ ...acc, [el.id]: el }), {})
        }),
        list: body => ({
            teams: () => toIdArray(body)
        }),
        queryKey: 'GET:teams',
        options: {
            method: httpMethods.GET
        }
    });

export function setIdLineUp(idLineUp, generateLineUp = true) {
    return {
        type: SET + ID_LINEUP,
        payload: { idLineUp },
        generateLineUp: generateLineUp
    };
}

export function setLineupType(type) {
    return {
        type: SET + LINEUP_TYPE,
        payload: { type }
    };
}

export function setParticipantCustomName(id, text, generateLineUp = true) {
    return {
        type: SET + PARTICIPANT_CUSTOM_NAME,
        payload: { id, text },
        generateLineUp: generateLineUp
    };
}

export function setParticipantCustomText(id, text, generateLineUp = true) {
    return {
        type: SET + PARTICIPANT_CUSTOM_TEXT,
        payload: { id, text },
        generateLineUp: generateLineUp
    };
}

export function setLineupTemplate(template, generateLineUp = true) {
    return {
        type: SET + LINEUP_TEMPLATE,
        payload: { template },
        generateLineUp: generateLineUp
    };
}

export function searchInputText(text) {
    return {
        type: SEARCH_INPUT_TEXT,
        payload: { text }
    };
}

export function setParticipantPitch(position, participant, generateLineUp = true) {
    return {
        type: SET + PARTICIPANT_PITCH,
        payload: { position, participant },
        generateLineUp: generateLineUp
    };
}

export function deleteParticipantPitch(position, generateLineUp = true) {
    return {
        type: DELETE + PARTICIPANT_PITCH,
        payload: { position },
        generateLineUp: generateLineUp
    };
}

export function setPitchLineupTemplate(template, generateLineUp = true) {
    return {
        type: SET + PITCH_LINEUP_TEMPLATE,
        payload: { template },
        generateLineUp: generateLineUp
    };
}

export function generateParticipantPitch(generateLineUp = true) {
    return {
        type: GENERATE + PARTICIPANT_PITCH,
        generateLineUp: generateLineUp
    };
}

export function postParticipantPitch() {
    return {
        type: POST + PARTICIPANT_PITCH,
        postLineUp: true
    };
}



/** WEBPACK FOOTER **
 ** ../src/dash/front/grid-maker-tool-page/actions.js
 **/